    
<template>
    <div class="dashBox">
        <a-spin :spinning="spinning"></a-spin>


        <div class="dashTitle">异常名分类</div>
        <a-empty v-if="pieData.length == 0" :description="'暂无数据'" style="margin-top:80px;" />

        <div :id="pid"  style="width: 100%;">

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            chartSys:null,
            spinning:false,
            pieData:[],
            startT:'',
            endT:'',
            logstorename:'',
            pid:'historyErrorPieID'
        }
    },
    methods: {
        //按日期统计数据
        analystData(app,startDate,endDate){
            if(!app){
                return
            }

            let that = this;
            that.logstorename = app;
            that.startT = startDate;
            that.endT = endDate;
            that.pieData = [];

            let params = {
                startDate:startDate,
                endDate:endDate,
                sysname:app,
                urlparams:false
            };
            that.spinning = true;
            that.$store.dispatch({
                type: "logservice/gethistorypie",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    this.pieData = res.data.data;
                    that.getDatailOption(res.data.data);
                }
                that.spinning = false;
            }).catch(() => {
                that.spinning = false;
            });
            
        },
        getDatailOption(resultData){

            let that = this;
            if(resultData.length == 0){
                if(that.chartSys){
                    that.chartSys.clear();
                    document.getElementById(that.pid).style.height = "0";
                }
                return
            }
            document.getElementById(that.pid).style.height = "360px";
            that.chartSys = that.$echarts.init(document.getElementById(that.pid));
            // 基于准备好的dom，初始化echarts实例
            // 绘制图表配置
            let option = {
                title: {
                    show:false
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    right: '5px',
                    top:'bottom',
                    show:false,
                },
                color:that.G.getChartColors(),
                series: [
                    {
                        name: '异常数',
                        type: 'pie',
                        radius: '50%',
                        data: resultData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },

                    },
                ],
            };
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function (data) {
                let record = {};
                let hostname = window.location.host;
                if(hostname.split('.')[0] != 'fpvip'){
                    record.projectname = 'app-logs-zl'
                }
                else{
                    record.projectname = 'vip-app-logs-zl'
                }
                record.logstorename = that.logstorename;
                record.mintime = that.startT + ' 00:00:00';
                record.maxtime = that.endT + ' 23:59:59';
                record.chartPerTime = '1小时';
                record.exception = data.name;
                localStorage.setItem("currentSystemMsg",JSON.stringify(record))

                that.$router.push({
                    path:'/monitorerror/errordetail'
                })
            });
        },
        chartResize(){
            let eleArr = [this.chartSys,this.chartDetail];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.chartResize);
    },
    watch:{

    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    }
}
</script>

<style scoped>
    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;

    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
    cursor: default;

    }
</style>

<style>
  #homeRequestBox .ant-card-body{
        padding-top: 0;
    }
</style>